import { Link as RouterLink } from "react-router";
import type { ComponentProps } from "react";

/**
 * `next/link` shim. Next의 Link는 `href`를, React Router는 `to`를 받는다.
 * 나머지 props(className, children, target…)는 그대로 넘긴다.
 *
 * 외부 주소(http로 시작)나 파일 다운로드는 라우터가 처리하면 안 되므로
 * 평범한 `<a>`로 떨어뜨린다 — 그러지 않으면 앱 안에서 404로 잡힌다.
 */
type Props = Omit<ComponentProps<typeof RouterLink>, "to"> & {
  href: string;
  prefetch?: boolean;
  replace?: boolean;
};

export default function Link({ href, prefetch: _prefetch, ...rest }: Props) {
  const external = /^(https?:)?\/\//.test(href) || href.startsWith("mailto:") || href.startsWith("tel:");
  if (external) {
    const { replace: _replace, href: _href, ...anchorProps } = rest as Props;
    return <a href={href} {...anchorProps} />;
  }
  return <RouterLink to={href} {...rest} />;
}
